// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import { 
    Dropdown,Icon,Drawer,
    Collapse,Button,Form,
    Input,FormItem,DropdownMenu,
    DropdownItem,Panel,Select,Option,
  } from 'iview';
import 'iview/dist/styles/iview.css';
import 'animate.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI)
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Icon', Icon);
Vue.component('Drawer', Drawer);
Vue.component('Collapse', Collapse);
Vue.component('Panel', Panel);
Vue.component('Button', Button);
Vue.component('Form', Form);
Vue.component('Input', Input);
Vue.component('FormItem', FormItem);
Vue.component('Select', Select);
Vue.component('Option', Option);

Vue.config.productionTip = false
window.$ = $

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js